import React,{useState} from 'react';
import CheckBox from '../../../UI/CheckBox';
import QuestionnaireModal from './QuestionnaireModal';
import {questinnare7Sub1,questinnare7Sub2} from '../../../../Constants/Questions';

const QuestionnaireCheckboxWrapper = ({reff,nextOnClick,onCheckBoxChange,dispError,onModalClick,display}) => {
    const [showQest7Sub1,setShowQest7Sub1] = useState(false);
    const [showQest7Sub2,setShowQest7Sub2] = useState(false);
    const onAnscheckSub1 = (e) => {
        setShowQest7Sub1(false);
        setShowQest7Sub2(false);
        if(e.target.checked == true){
            if(e.target.value=== "27" ){
                setShowQest7Sub1(true);
            }else if(e.target.value=== "32"){
                setShowQest7Sub2(true);  
            }
        }
    }
    return (
        <>
            <div className="radio-box question"  ref={reff} >
                <h4>
                Q7 - Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                </h4>
                <div className="form-group">
                    <div className="cstfrm" id="question_group_66" > 
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-1" value="26" dataId="26"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-2" value="27" dataId="27" 
                            onChange={onCheckBoxChange}
                            onClick={onAnscheckSub1}
                        /> 
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-3" value="28" dataId="28"
                            onChange={onCheckBoxChange}
                        /> 
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-4" value="29" dataId="29"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-5" value="30" dataId="30"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-6" value="31" dataId="31"
                            onChange={onCheckBoxChange}
                        /> 
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-7" value="32" dataId="32" 
                            onClick={onAnscheckSub1}
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-8" value="33" dataId="33"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-9" value="34" dataId="34"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-10" value="35" dataId="35"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-11" value="36" dataId="36"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-12" value="37" dataId="37"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-13" value="38" dataId="38"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox 
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-14" value="39" dataId="39"
                            onChange={onCheckBoxChange}
                        />
                        <button type="button" className="btn-primary form-control" onClick={nextOnClick} > Next ></button>
                        <span className={`error_msg ${dispError}`}>Please select atleast one option</span>
                    </div>
                </div>
            </div>
            <QuestionnaireModal questArr={questinnare7Sub1} popDisplay={showQest7Sub1} onModalClick={onModalClick} />
            <QuestionnaireModal questArr={questinnare7Sub2} popDisplay={showQest7Sub2} onModalClick={onModalClick}/>
        </>
    )
}

export default QuestionnaireCheckboxWrapper;